import React from 'react';
import Modal from 'react-modal';

const ConfirmationDeleteModal = ({ isOpen, onRequestClose, onConfirm, message }) => (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Confirm Deletion"
      className="d-flex justify-content-center pad-bottom-2 space-bottom-2"
      ariaHideApp={false}
      overlayClassName="overlay"
    >
      <div className="bg-light col-md-4 mx-auto space-top-2 pad-top-1 pad-bottom-1 pad-left-2 pad-right-2">
        <div className="modal-content">
          <div className="container">
            <h4 className="modal-title d-inline text-center">{message}</h4>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={onConfirm}
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onRequestClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );

export default ConfirmationDeleteModal;